var Invocation = require('../api/Invocation');

var InvoiceActions = {
    getFilteredLegacyInvoices: function (pageNumber) {
        Invocation.invoice.getFilteredLegacyInvoices(pageNumber);
    },

    getInvoices: function (pageNumber, options) {
        Invocation.invoice.getInvoices(pageNumber, options);
    }
};
module.exports = InvoiceActions;



// WEBPACK FOOTER //
// ./app/actions/InvoiceActions.js